{
  "api_settings_upsell": {
    "title": "Connect your systems with the SparkLayer API.",
    "subtitle": "The SparkLayer API helps you integrate your pricing with your SparkLayer setup, making for a more seamless integration for your B2B operation.",
    "learn_button": "Learn more",
    "intro": "Here's what you can do with the SparkLayer API:",
    "features": {
      "pricing": {
        "title": "Keep pricing up-to-date",
        "description": "Easily sync your product pricing from backend systems so your customers always see accurate pricing."
      },
      "integration": {
        "title": "Secure and reliable integration",
        "description": "Using REST principles with OAuth2 for secure authentication."
      }
    },
    "disclaimer": "Please note: The SparkLayer API is an advanced feature of SparkLayer and will require technical expertise to implement."
  },
  "modals": {
    "create_key": {
      "submit": "Create API Key",
      "header": "Create new API Key",
      "body": "To get started, please enter a name below.",
      "name_placeholder": "e.g. Production API Key",
      "close": "Close"
    },
    "show_key": {
      "header": "Create new API Key",
      "warning": "The 'Client Secret' will not be shown again so please ensure to make a copy."
    },
    "delete_confirm": {
      "header": "Delete {keyName}?",
      "body": "Are you sure you want to delete the API key {keyName}? This can't be undone.",
      "delete": "Delete API key"
    }
  }
}
